<template>
  <div class="modal" v-if="forceReload">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">EDIT SBUJK</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="kbli-modal-filter-search" style="padding: 0 10px">
          <form v-on:submit.prevent="noop">
            <div class="input-search">
              <b-input-group>
                <template #append>
                  <b-input-group-text>
                    <strong>
                      <i class="fas fa-times" style="cursor:pointer; marginRight: 10px" @click="resetPlaceholder()"
                        v-if="subSearch.length !== '' && subSearch"></i>
                      <i class="fas fa-search" style="cursor:pointer"></i>
                    </strong>
                  </b-input-group-text>
                </template>
                <b-form-input type="text" placeholder="Cari SBUJK" v-model="subSearch"
                  @keyup="searchRun()"></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="modal-body" v-if="sbujkData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column10">Kode</div>
            <div class="column20 mr10">Klasifikasi</div>
            <div class="column40 mr10">Sub Klasifikasi</div>
            <div class="column20">Kualifikasi</div>
          </div>
          <div class="horizontal" v-for="(item, index) in sbujk" :key="index">
            <div class="column5">
              <input class="modal-input-checkbox" type="checkbox" :id="index" :value="item.id" v-model="choose" />
            </div>
            <div class="column10">{{ item.kode }}</div>
            <div class="column20 mr10">{{ item.klasifikasi }}</div>
            <div class="column40 mr10">{{ item.sub_klasifikasi }}</div>
            <div class="column20">{{ item.kualifikasi }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="submit()">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sbujk: [],
      choosedSbujk: [],
      subData: [],
      subSearch: '',
      forceReload: true,
    }
  },
  computed: {
    choose: {
      get: function () {
        return this.choosedSbujk
      },
      set: function (newValue) {
        let newItem = ''
        let newChoose = []
        if (newValue) {
          newChoose = newValue
          newItem = newChoose.filter(i => !this.choosedSbujk.includes(i))
        }
        let createdItem = this.sbujk.filter(i => i.id == newItem)
        if (
          newChoose.length > this.choosedSbujk.length &&
          newChoose.length - this.choosedSbujk.length == 1
        ) {
          if (
            confirm(
              `Ingin menambahkan ${createdItem[0].kode}-${createdItem[0].sub_klasifikasi}?`
            )
          ) {
            this.choosedSbujk = newChoose
            this.$store.dispatch('addEdit/addItemSbujk', {
              vendor_id: this.$get(this.$store, 'state.level1.vendorId'),
              sbujk_id: createdItem[0].id,
              onSuccess: async () => {
                await this.$store.commit('level1/INFO_CALLBACK', {
                  tab: 'informasi',
                  updateInfoSuccess: async () => {
                    await this.changeSbujkDefault()
                  },
                })
                // await this.setUpData()
              },
            })
          } else {
            let newList = newChoose.filter(i => !newItem.includes(i))
            this.choosedSbujk = newList

            this.forceReload = false
            this.$nextTick(() => {
              this.forceReload = true
            })
          }
        }
        if (
          this.choosedSbujk.length > newChoose.length &&
          this.choosedSbujk.length - newChoose.length == 1
        ) {
          let delItem = this.choosedSbujk.filter(i => !newChoose.includes(i))
          let deletedItem = this.sbujk.filter(i => i.id == delItem[0])
          if (
            confirm(
              `Ingin menghapus ${deletedItem[0].kode}-${deletedItem[0].sub_klasifikasi}?`
            )
          ) {
            this.$store.dispatch('addEdit/deleteSbujk', {
              sbujk_id: deletedItem[0].id_sbujk_vendor,
              onSuccess: async () => {
                await this.$store.commit('level1/INFO_CALLBACK', {
                  tab: 'informasi',
                  updateInfoSuccess: async () => {
                    await this.changeSbujkDefault()
                  },
                })
                // await this.setUpData()
              },
            })
          } else {
            this.forceReload = false
            this.$nextTick(() => {
              this.forceReload = true
            })
          }
        }
      },
    },
    sbujkData: async function () {
      return this.setUpData()
    },
  },
  methods: {
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subData

      let filteredList = []
      for (let i in list) {
        if (
          list[i].sub_klasifikasi.toLowerCase().indexOf(search.toLowerCase()) !=
          -1
        ) {
          filteredList.push(list[i])
        }
      }

      this.sbujk = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      // this.sbujk = this.subData
      this.searchRun()
    },
    async submit() {
      this.closeModal()
    },
    async setUpData() {
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      const getSbujk = await this.$getSbujk()
      const defaultSbujk = await this.$store.state.addEdit.choosedSbujk

      let reduceSbujk = await getSbujk.reduce(
        (a, b) => ({ ...a, [b.id]: b }),
        {}
      )

      let reduceDefault =
        (await defaultSbujk) &&
        defaultSbujk.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reduceSbujk, ...reduceDefault }

      let newKbli = await Object.values(combine)

      this.sbujk = await newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.subData = newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.choosedSbujk = await defaultSbujk.map(list => {
        return list.id
      })

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
    },
    changeSbujkDefault() {
      const info = this.$store.state.level1.information
      let storeSbujk = []
      if (info.sbujk && info.sbujk.length > 0) {
        for (let i in info.sbujk) {
          let newSbujk = info.sbujk[i].master_sbujk
          newSbujk['checked'] = true
          newSbujk['id_sbujk_vendor'] = info.sbujk[i].id
          storeSbujk.push(newSbujk)
        }
      }
      this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'choosedSbujk',
        value: storeSbujk,
      })
      this.choosedSbujk = storeSbujk.map(list => {
        return list.id
      })
    },
    closeModal() {
      this.$store.commit('modalStore/SET_SBUJK_MODAL', false)
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
